import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PartnerDashboardService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPartnerInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerDashboard/GetPartnerInfo', data, messageService);
    }

    public getPartnerDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerDashboard/GetPartnerDashboard', data, messageService);
    }
}
